import React, { Component, Fragment } from 'react'
import { TableRow, TableCell, MenuItem, IconButton } from '@material-ui/core'
import { Delete } from '@material-ui/icons'

// utils
import { onChangeEditHOF } from '../../../utils/common'
import { hasAccess } from '../../../utils/api'

import { EditableSelect, EditableReactSelectAsync } from '../../common/EditableComponents'
import EditActionIconComponent from '../../common/EditActionIconComponent'
import _ from 'lodash'
import { connect } from 'react-redux'

class WeedMapMenuListItemV3 extends Component {
  constructor(props) {
    super(props)
    this.timeout = null
    this.state = {
      selectedBrand: null,
    }
  }

  componentDidMount() {}

  onChange = onChangeEditHOF(this.props.onChange)

  componentWillReceiveProps(nextProps) {
    if (nextProps.weedmapCategory !== this.props.weedmapCategory) {
      this.onChangeWeedmapTags(0)({ target: { value: nextProps.weedmapCategory } })
    }
  }

  componentDidUpdate(prevProps, prevState) {}

  onSave = () => {
    const { thirdPartyProductId } = this.props.data

    if (!thirdPartyProductId) {
      this.props.showError(`Weedmap product is not available for the selected brand`)
      return
    }

    this.props.onSave((response) => this.props.disableEdit())
  }

  onCancel = () => {
    this.props.onCancel()
  }

  enableEdit = () => {
    const { data } = this.props

    if (this.props.weedmapCategory) {
      this.props.getWmMenuApiBrands(data.thirdPartyBrandName).then((res) => {
        let options =
          _.compact((res || {}).values || []).map((brand) => ({
            ...brand,
            label: brand.name,
            value: brand.menuApiBrandId,
          })) || []
        if (options.length === 1) {
          this.props.onChange('thirdPartyBrandId', options[0].menuApiBrandId)
        }
      })
      this.props.enableEdit()
    } else {
      this.props.showError('Please select weedmap category before proceeding')
    }
  }

  onChangeWeedmapTags = (index) => (event) => {
    const { value = '' } = event.target
    const { wmTags = [] } = this.props.data || {}
    const updatedWmTags = [...wmTags]
    updatedWmTags[index] = value
    for (let i = index + 1; i < wmTags.length; ++i) {
      updatedWmTags[i] = ''
    }
    this.props.onChange('wmTags', updatedWmTags)
  }

  onChangeBrand = (value) => {
    const brand = (value && value.value) || ''
    const { wmTags = [] } = this.props.data

    const updatedWmTags = [wmTags[0] || '']

    this.props.onChange('thirdPartyBrandId', brand)
    this.props.onChange('wmTags', updatedWmTags)
    this.props.onChange('thirdPartyProductId', '')
    this.props.onChange('thirdPartyProduct', null)

    if (brand) {
      this.setState({ selectedBrand: value })
      this.props.getWmMenuApiProducts('', value.value, value.label, 0, 50)
    }
  }

  onRowCheck = (event) => {
    const { data } = this.props
    this.props.onRowCheck(data, event)
  }

  onChangeProduct = (value) => {
    this.props.onChange('thirdPartyProduct', value)
    this.props.onChange('thirdPartyProductId', value && value.id)
  }

  loadThirdPartyBrands = (term, callback) => {
    this.props.onChange('thirdPartyBrandId', '')
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    if (term.length === 0) {
      callback(null, { options: [] })
      return
    }

    this.timeout = setTimeout(() => {
      this.props.getWmMenuApiBrands(term).then((res) => {
        let options =
          _.compact((res || {}).values || []).map((brand) => ({
            ...brand,
            label: brand.name,
            value: brand.menuApiBrandId,
          })) || []
        options = [...options]
        callback(null, { options })
      })
    }, 500)
  }

  loadThirdPartyProducts = (term, callback) => {
    this.props.onChange('thirdPartyProductId', '')
    this.props.onChange('thirdPartyProduct', null)
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    if (term.length === 0 || this.state.selectedBrand == null) {
      callback(null, { options: [] })
      return
    }

    this.timeout = setTimeout(() => {
      this.props
        .getWmMenuApiProducts(
          term,
          this.state.selectedBrand.value,
          this.state.selectedBrand.label,
          0,
          50,
        )
        .then((res) => {
          let options =
            _.compact((res || {}).values || []).map((product) => ({
              ...product,
              label: product.name,
              value: product.id,
            })) || []
          options = [...options]
          callback(null, { options })
        })
    }, 500)
  }

  onDelete = () => {
    const { data } = this.props
    this.props.onDelete(data.productId)
  }

  render() {
    const {
      data,
      editMode,
      brandsList = [],
      product = {},
      thirdPartyProducts = [],
      thirdPartyBrands = [],
    } = this.props

    let selectedThirdPartyBrand = _.compact(thirdPartyBrands).find(
      (brand) => brand.menuApiBrandId === parseInt(data.thirdPartyBrandId),
    )
    let selectedThirdPartyProduct = _.compact(thirdPartyProducts).find(
      (product) => product.id === data.thirdPartyProductId,
    )

    return (
      <TableRow>
        <TableCell className="cell-wrap-word">{product.name}</TableCell>
        <TableCell className="cell-wrap-word">
          <EditableSelect
            value={data.weedmapCategory}
            onChange={this.onChange('weedmapCategory')}
            valueToRender={product.brandName || ''}
            editMode={false}
            MenuProps={{ className: 'no-backdrop-select ' }}
          >
            {brandsList.map((item, index) => {
              return (
                <MenuItem key={index} value={item.id}>
                  {item.name}
                </MenuItem>
              )
            })}
          </EditableSelect>
        </TableCell>
        <TableCell className="cell-wrap-word" style={{ minWidth: 180 }}>
          <EditableReactSelectAsync
            options={[
              ...((thirdPartyBrands &&
                thirdPartyBrands.map((brand) => ({
                  ...brand,
                  label: brand.name,
                  value: brand.menuApiBrandId,
                }))) ||
                []),
            ]}
            value={
              selectedThirdPartyBrand
                ? {
                    label: selectedThirdPartyBrand.name || '',
                    value: selectedThirdPartyBrand.menuApiBrandId || '',
                  }
                : null
            }
            onChange={this.onChangeBrand}
            valueToRender={
              (
                <Fragment>
                  {data.thirdPartyBrandName}
                  <br />
                </Fragment>
              ) || ''
            }
            editMode={editMode}
            MenuProps={{ className: 'no-backdrop-select' }}
            autoload={false}
            loadOptions={this.loadThirdPartyBrands}
            onBlurResetsInput={false}
            cache={false}
            placeholder="Select Brand..."
          ></EditableReactSelectAsync>
          <EditableReactSelectAsync
            options={[
              ...((thirdPartyProducts &&
                thirdPartyProducts.map((product) => ({
                  ...product,
                  label: product.name,
                  value: product.id,
                }))) ||
                []),
            ]}
            value={
              selectedThirdPartyProduct
                ? {
                    label: selectedThirdPartyProduct.name || '',
                    value: selectedThirdPartyProduct.id || '',
                  }
                : null
            }
            onChange={this.onChangeProduct}
            valueToRender={
              (
                <Fragment>
                  {data.thirdPartyProductName}
                  <br />
                </Fragment>
              ) || ''
            }
            editMode={editMode}
            MenuProps={{ className: 'no-backdrop-select' }}
            autoload={false}
            loadOptions={this.loadThirdPartyProducts}
            onBlurResetsInput={false}
            cache={false}
            placeholder="Select Product..."
            disabled={!selectedThirdPartyBrand}
            className="margin-top-xs"
          />
        </TableCell>
        <TableCell className="cell-wrap-word">
          {!editMode ? (
            <div className="edit-actions pull-right">
              <IconButton className="danger-button" onClick={this.onDelete}>
                <Delete />
              </IconButton>
            </div>
          ) : null}
          {hasAccess() ? (
            <div className="pull-right">
              <EditActionIconComponent
                onSave={this.onSave}
                onCancel={this.onCancel}
                onEdit={this.enableEdit}
                editMode={editMode}
                className="edit-actions"
              />
            </div>
          ) : null}
        </TableCell>
      </TableRow>
    )
  }
}

function mapStateToProps(state) {
  return { ...state }
}

export default connect(mapStateToProps)(WeedMapMenuListItemV3)



// WEBPACK FOOTER //
// ./src/components/WeedmapInfo/WeedMapMenuList/WeedMapMenuListItemV3.js